export default (options = { initialValues: [], onChangeCallback: null, disabledItems: [], selectParentOnCheckChildren: false }) => ({
    checkboxList    : undefined,
    rootAllCheckbox : undefined,
    parentCheckboxes: undefined,
    normalCheckboxes: undefined,

    selectedItems: options.initialValues,
    disabledItems: options.disabledItems || [],

    get selectedCheckboxes() {
        const checkboxes = this.$el.querySelectorAll('input[type="checkbox"]:not(input[data-toggle="rootAll"]):checked:not(:disabled)');
        return [...checkboxes].map(checkbox => checkbox.value);
    },

    get isAllChecked() {
        return [...this.$el.querySelectorAll('input[type="checkbox"]')].every(checkbox => checkbox.checked);
    },

    init() {
        this.checkboxList     = this.$el.children,
        this.rootAllCheckbox  = this.$el.querySelector('input[data-toggle="rootAll"]');
        this.parentCheckboxes = this.$el.querySelectorAll('li:has(input[data-toggle="all"])');
        this.normalCheckboxes = this.$el.querySelectorAll('input[type="checkbox"]:not([data-toggle="rootAll"]):not([data-toggle="all"])');

        if (this.rootAllCheckbox) {
            this.rootAllCheckbox.addEventListener('change', () => {
                // debugger;
                const currentStatus = this.rootAllCheckbox.checked;
                const checkboxes = this.$el.querySelectorAll('input[type="checkbox"]');
                for (let i = 0; i < checkboxes.length; i++) {
                    const checkbox = checkboxes[i];
                    checkbox.checked = currentStatus;
                }

                this.selectedItems = this.selectedCheckboxes;
            });
        }

        for (let i = 0; i < this.parentCheckboxes.length; i++) {
            const parentCheckbox = this.parentCheckboxes[i].querySelector('input[type="checkbox"]');
            const childrenCheckboxes = this.parentCheckboxes[i].querySelectorAll('ul')[0].querySelectorAll('input[type="checkbox"]');

            parentCheckbox.addEventListener('change', () => {
                const currentStatus = parentCheckbox.checked;
                for (let j = 0; j < childrenCheckboxes.length; j++) {
                    const checkbox = childrenCheckboxes[j];
                    checkbox.checked = currentStatus;
                }

                this.selectedItems = this.selectedCheckboxes;

                if (this.rootAllCheckbox !== undefined && this.rootAllCheckbox !== null){
                    if (!this.rootAllCheckbox.checked)
                        return;
                    this.rootAllCheckbox.indeterminate = (this.rootAllCheckbox.checked && !this.isAllChecked);
                }
            });

            // parentCheckbox.addEventListener('childrenChange', () => {});

            childrenCheckboxes.forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    const allChecked = [...childrenCheckboxes].every(checkbox => checkbox.checked);
                    const someChecked = [...childrenCheckboxes].some(checkbox => checkbox.checked);

                    if(options.selectParentOnCheckChildren !== undefined){
                        if (!options.selectParentOnCheckChildren){
                            parentCheckbox.checked = allChecked;
                            parentCheckbox.indeterminate = someChecked && !allChecked;
                        }else{
                            if (allChecked){
                                parentCheckbox.checked = true;
                                parentCheckbox.indeterminate = false;
                            }else if (someChecked){
                                parentCheckbox.checked = true;
                                parentCheckbox.indeterminate = true;
                            }else{
                                parentCheckbox.checked = false;
                                parentCheckbox.indeterminate = false;
                            }
                        }
                    }

                    this.selectedItems = this.selectedCheckboxes;

                    if (this.rootAllCheckbox !== undefined && this.rootAllCheckbox !== null){
                        if (!this.rootAllCheckbox.checked)
                            return;
                        this.rootAllCheckbox.indeterminate = (this.rootAllCheckbox.checked && !this.isAllChecked);
                    }
                });
            });

        }

        if (this.rootAllCheckbox !== undefined && this.rootAllCheckbox !== null){
            for (let i = 0; i < this.normalCheckboxes.length; i++) {
                this.normalCheckboxes[i].addEventListener('change', () => {
                    this.rootAllCheckbox.indeterminate = (this.rootAllCheckbox.checked && !this.isAllChecked);
                });
            }
        }

        if (options.onChangeCallback && typeof options.onChangeCallback === 'function') {
            [...this.$el.querySelectorAll('input[type="checkbox"]')].forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    options.onChangeCallback(this.selectedCheckboxes, this)
                });
            });
        }
    },

    setValues(values){
        this.selectedItems = values;
    },

    setDisabled(values){
        this.disabledItems = values;
    }
})
